export default {
  getCompanies: (state) => state.companies,
  getCompaniesV2: (state) => state.companies,
  getSimplifiedCompanies: (state) => state.simplifiedCompanies,
  getCompany: (state) => state.company,
  getCompanySuperBonus: (state) => {
    const superBonus = { ...state.superBonus };
  
    if (!superBonus.dateFrom) {
      const currentDate = new Date();
      superBonus.dateFrom = currentDate;
      const toDate = new Date();
      toDate.setDate(currentDate.getDate() + 365);
      superBonus.dateTo = toDate;
    }

    if (!superBonus.dateTo) {
      const toDate = new Date();
      toDate.setDate(toDate.getDate() + 365);
      superBonus.dateTo = toDate;
    }
  
    return superBonus;
  },
  getCompanyArticles: (state) => state.companyArticles,
  getCommercialists: (state) => state.commercialists,
  getCommercialistsForCompanies: (state) => state.commercialistsForCompanies,
  getMasterCompanies: (state) => state.masterCompanies,
  getParentCompanies: (state) => state.parentCompanies,
  getSubCompaniesByParent: (state) => state.subCompaniesByParent,
  getPager: (state) => state.pager,
  getFilteredCompanies: (state) => (parentId) => state.companies.filter(item => item.id != parentId),
  getTowns: (state) => state.towns,
  getTown: (state) => state.town,
  getSimplifiedTowns: (state) => {
    return state.towns.map((item) => {
      return {
        label: item.title,
        id: item.id
      };
    });
  },
  getShippingTowns: (state) => state.shippingTowns,
  getUsers: (state) => state.users,
  getSelectedUser: (state) => state.selectedUser,
  getUserShippingInfo: (state) => state.userShippingInfo,
  getToken: (state) => state.token,
  getLoggedUser: (state) => state.profile,
  getProfile: (state) => state.userProfile,
  getCountries: (state) => state.countries,
  getSimplifiedCountries: (state) => {
    return state.countries.map((item) => {
      return {
        label: item.title,
        id: item.id
      };
    });
  },
  getCountry: (state) => state.country,
  getCategories: (state) => state.categories,
  getParentCategories: (state) => state.parentCategories,
  getChildCategories: (state) => state.childCategories,
  getSimplifiedCategories: (state) => state.simplifiedCategories,
  getCategoriesTree: (state) => {
    const getCategoryTree = (categories, parentCategoryId = null) => {
      return categories
        .filter(i => i.parentCategoryId === parentCategoryId)
        .map(j => {
          const obj = {
            ...j,
            children: getCategoryTree(categories, j.id),
          };

          if (!obj.children.length) delete obj.children;

          return obj;
      });
    };
    
    const categories = [...state.simplifiedCategories].map(i => ({
      ...i,
      label: i.title,
      childVisible: false,
      order: i.order || 0,
    }));

    const sortMethod = (a, b) => a.order - b.order;

    return getCategoryTree(categories.sort(sortMethod));
  },
  getCategory: (state) => state.category,
  getCategoryArticles: (state) => state.categoryArticles,
  getPriorityArticles: (state) => state.categoryPriorityArticles,
  getChildrenCategoryIds: (state) => (parentId) => {
    const getChildCategoryIds = (categories, categoryId) => {
      const childIds = [];

      const getChildren = (id) => {
        categories.filter((c) => c.parentCategoryId === id).forEach((child) => {
          childIds.push(child.id);
          getChildren(child.id);
        });
      };

      getChildren(categoryId);
      return childIds;
    };

    return getChildCategoryIds(state.articleFilters?.categories || [], parentId);
  },

  // Articles
  getArticles: (state) => state.articles,
  getSearchVariations: (state) => state.searchVariations,
  getArticle: (state) => state.article,
  getPresentationRequests: (state) => state.presentationRequests,
  getArticleFilters: (state) => state.articleFilters,
  getCopyOfArticle: (state) => state.articleCopy,

  // Banks
  getBanks: (state) => state.banks,
  getBank: (state) => state.bank,
  getCurrencies: (state) => state.currencies,
  getCurrency: (state) => state.currency,
  getMeasurementUnits: (state) => state.measurementUnits,
  getMeasurementUnit: (state) => state.measurementUnit,
  getBrands: (state) => state.brands,
  getCompanySuperBonusPaged: (state) => state.superBonuses,
  getBrand: (state) => state.brand,
  getTaxes: (state) => state.taxes,
  getExpressPosts: (state) => state.expressPosts,
  getExpressPost: (state) => state.expressPost,
  getTabs: (state) => state.tabs,
  getTab: (state) => state.tab,
  getProductSales: (state) => state.productSales,
  getProductSale: (state) => state.productSale,
  getInterestsAreas: (state) => state.interestsAreas,
  getInterestsArea: (state) => state.interestsArea,
  getCustomerBankAccounts: (state) => state.customerBankAccounts,
  getCustomerBankAccount: (state) => state.customerBankAccount,
  getBlogs: (state) => state.blogs,
  getBlog: (state) => state.blog,
  getCopyOfBlog: (state) => state.blogCopy,
  getNewsletters: (state) => state.newsletters,
  getTermsOfServices: (state) => state.terms,
  getAttributes: (state) => state.attributes,
  getAttribute: (state) => state.attribute,
  getAttributesAsObj: (state) => {
    const result = {};
    state.attributes.forEach((item) => {
      result[item.id] = {
        ...item,
        attributeProperties: item.attributeProperties.map((i) => {
          return {
            label: i.title,
            id: i.id
          };
        })
      }
    });

    return result;
  },
  getArticleVariations: (state) => state.articleVariations,
  getVariationsWarehouseTowns: (state) => state.variationsWarehouseTowns,
  getSystemMessages: (state) => state.systemMessages,
  getSystemMessagesAsAdmin: (state) => state.systemMessages,
  getHighlightedBrands: (state) => state.highlightedBrands,
  getHighlightedBrand: (state) => state.highlightedBrand,
  getJumbotrons:(state) => state.jumbotrons,
  getJumbotron:(state) => state.jumbotron,
  getHighlightedCategories: (state) => state.highlightedCategories,
  getHighlightedCategory: (state) => state.highlightedCategory,
  getBanners: (state) => state.banners,
  getBanner: (state) => state.banner,
  getNewlyAddedArticles: (state) => state.newlyAddedArticles,
  getArticleTags: (state) => state.articleTags,
  getTags: (state) => state.tags,
  getTag: (state) => state.tag,
  getShoppingCarts: (state) => state.shoppingCarts,
  getShoppingCart: (state) => state.shoppingCart,
  getWishLists: (state) => state.wishLists,  
  getWishList: (state) => state.wishList,

  // Orders
  getOrders: (state) => state.orders,
  getOrder: (state) => state.order,
  getOrderStates: (state) => state.orderStates,
  mergeOrders: (state) => state.mergeOrdersResponse,
  // Roles
  getRoles: (state) => state.roles,
  getRolesSimplified: (state) => state.simplifiedRoles,
  getRole: (state) => state.role,

  // Permissions
  getPermissions: (state) => state.permissions,
  
  // Service managers
  getServiceManagers: (state) => state.serviceManagers,
  getServiceManager: (state) => state.serviceManager,

  // Customer files
  getCustomerFiles: (state) => state.customerFiles,
  getCustomerFile: (state) => state.customerFile,

  // Complaints
  getComplaints: (state) => state.complaints,
  getComplaint: (state) => state.complaint,

  // Media library
  getMediaLibrary: (state) => state.mediaLibrary,

  // Meta SEO
  getMetaSeo: (state) => state.metaSeo,

  // Reviews
  getReviews: (state) => state.reviews,
  getReview: (state) => state.review,

  // Promo codes
  getPromoCodes: (state) => state.promoCodes,
  getPromoCode: (state) => state.promoCode,

  // Gift cards
  getGiftCards: (state) => state.giftCards,
  getGiftCard: (state) => state.giftCard,

  // Top brand list
  getTopBrandList: (state) => state.topBrandList,
  getTopBrand: (state) => {
    return {
      ...state.topBrandListSingle,
      topBrandItems: state.topBrandListSingle?.topBrandItems?.map(({ brandId }) => brandId),
    };
  },

  // Offers
  getOffers: (state) => state.offers,
  getAdvancedOffers: (state) => state.offers,
  getOffer: (state) => state.offer,
  getAdvancedOffer: (state) => state.offer,

  // Personal data change requests
  getPersonalDataChangeRequests: (state) => state.personalDataChangeRequests,
  getPersonalDataChangeRequest: (state) => state.personalDataChangeRequest,

  // Settings
  getSettings: (state) => state.settings,
  getShowOffers: (state) => state.showOffers,
  getShowAdvancedOffers: (state) => state.showAdvancedOffers,

  // B2C Settings
  getB2CSettings: (state) => state.b2cSettings,

  // Cleaning areas
  getCleaningAreas: (state) => state.cleaningAreas,
  getParentCleaningAreas: (state) => state.parentCleaningAreas,
  getCleaningArea: (state) => state.cleaningArea,

  // Cleaning plan note icons
  getCleaningPlanNoteIcons: (state) => state.cleaningPlanNoteIcons,
  getCleaningPlanNoteIcon: (state) => state.cleaningPlanNoteIcon,

  // Cleaning plans
  getCleaningPlans: (state) => state.cleaningPlans,
  getCleaningPlan: (state) => state.cleaningPlan,

  // Price policies
  getPricePolicies: (state) => state.pricePolicies,
  getPricePolicy: (state) => state.pricePolicy,
  getPricePolicyItems: (state) => state.pricePolicyItems,
  getDefaultPricePolicyTypes: (state) => state.defaultPricePolicyTypes,

  // Dashboard
  getDashboardData: (state) => state.dashboardData,

  // Out of stock articles
  getOutOfStockArticles: (state) => state.outOfStockArticles,
  getOutOfStockArticle: (state) => state.outOfStockArticle,

  // Customer requests
  getB2BCustomerRequests: (state) => state.customerRequests,

  // Allowed document extensions
  getAllowedDocumentExtensions: (state) => state.allowedDocumentExtensions.map(({id, documentType}) => ({ id, label: documentType})),

  // loggedUserPermissions
  getLoggedUserPermissions: (state) => state.loggedUserPermissions,
};
